import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { playPop, playSelect, playKaChing } from '../sounds';
import './RSVPForm.css';

function RSVPForm({ onSubmit }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    attending: '',
    adults: 1,
    kids: 0,
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'attending') playSelect();
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleIncrement = (field) => {
    playPop();
    setFormData(prev => ({ ...prev, [field]: prev[field] + 1 }));
  };

  const handleDecrement = (field) => {
    const min = field === 'adults' ? 1 : 0;
    setFormData(prev => {
      const newVal = Math.max(min, prev[field] - 1);
      if (newVal !== prev[field]) playPop();
      return { ...prev, [field]: newVal };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const body = new URLSearchParams({
      'form-name': 'rsvp',
      ...formData,
      adults: String(formData.adults),
      kids: String(formData.kids)
    });
    playKaChing();

    // Submit to Netlify Forms
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    }).catch(() => {});

    // Send confirmation email (don't block navigation)
    fetch('/.netlify/functions/send-confirmation', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
      .then(res => { if (!res.ok) console.error('Email function error:', res.status); })
      .catch(err => console.error('Email function failed:', err));

    onSubmit(formData);
    navigate('/confirmation');
  };

  return (
    <div className="checkout-container">
      <div className="checkout-card">
        <div className="checkout-header">
          <div className="bakery-logo">
            <span className="cupcake-icon">🥧</span>
            <h1>BABY SHOWER</h1>
            <p className="tagline">A little cutie pie is on the way, let's celebrate!</p>
            <div className="header-details">
              <span>Hosted by Patrisha & Bryan</span>
              <span>March 14, 2026 · 2:00 PM</span>
              <span>13954 Hamlin St., Valley Glen, CA 91401</span>
            </div>
          </div>
        </div>

        {/* <div className="order-menu">
          <h2>🎀 Your Order 🎀</h2>
          <div className="menu-items">
            <div className="menu-item">
              <span className="item-emoji">🍰</span>
              <div className="item-details">
                <span className="item-name">Food & Treats</span>
                <span className="item-desc">Delicious bites</span>
              </div>
              <span className="item-price">$YUMMY</span>
            </div>
            <div className="menu-item">
              <span className="item-emoji">🥤</span>
              <div className="item-details">
                <span className="item-name">Drinks</span>
                <span className="item-desc">Refreshing beverages</span>
              </div>
              <span className="item-price">$GREAT</span>
            </div>
            <div className="menu-item">
              <span className="item-emoji">🎉</span>
              <div className="item-details">
                <span className="item-name">Fun & Games</span>
                <span className="item-desc">Celebration vibes</span>
              </div>
              <span className="item-price">$5.00</span>
            </div>
          </div>
        </div> */}

        <form onSubmit={handleSubmit} className="checkout-form" name="rsvp" data-netlify="true" data-netlify-honeypot="bot-field">
          <input type="hidden" name="form-name" value="rsvp" />
          <input type="hidden" name="bot-field" />
          <input type="hidden" name="adults" value={formData.adults} />
          <input type="hidden" name="kids" value={formData.kids} />
          <div className="form-section">
            <h3>Contact Information</h3>
            
            <div className="form-group">
              <label>Name *</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Enter your name"
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="your@email.com"
                />
              </div>
              <div className="form-group">
                <label>Phone</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="(555) 123-4567"
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h3>RSVP Details</h3>
            
            <div className="form-group">
              <label>Will you be joining us? *</label>
              <div className="radio-group">
                <label className="radio-card">
                  <input
                    type="radio"
                    name="attending"
                    value="yes"
                    checked={formData.attending === 'yes'}
                    onChange={handleChange}
                    required
                  />
                  <div className="radio-content">
                    <span className="radio-icon">✓</span>
                    <span className="radio-text">Yes! Count me in!</span>
                  </div>
                </label>
                <label className="radio-card">
                  <input
                    type="radio"
                    name="attending"
                    value="no"
                    checked={formData.attending === 'no'}
                    onChange={handleChange}
                  />
                  <div className="radio-content">
                    <span className="radio-icon">✗</span>
                    <span className="radio-text">Sorry, can't make it</span>
                  </div>
                </label>
              </div>
            </div>

            {formData.attending === 'yes' && (
              <div className="form-group-container">
                <div className="form-group">
                  <label>Number of Adults</label>
                  <div className="counter-row">
                    <button type="button" className="counter-btn" onClick={() => handleDecrement('adults')}>−</button>
                    <span className="counter-value">{formData.adults}</span>
                    <button type="button" className="counter-btn" onClick={() => handleIncrement('adults')}>+</button>
                  </div>
                </div>
                <div className="form-group">
                  <label>Number of Kids</label>
                  <div className="counter-row">
                    <button type="button" className="counter-btn" onClick={() => handleDecrement('kids')}>−</button>
                    <span className="counter-value">{formData.kids}</span>
                    <button type="button" className="counter-btn" onClick={() => handleIncrement('kids')}>+</button>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="form-section">
            <div className="form-group">
              <label>Message for Mom-to-be 💕</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Share your sweet wishes..."
                rows="3"
              />
            </div>
          </div>

          {/* <div className="order-total">
            <div className="total-row">
              <span>Subtotal</span>
              <span>$AMAZING</span>
            </div>
            <div className="total-row">
              <span>Joy & Love</span>
              <span>$INFINITE</span>
            </div>
            <div className="total-row grand-total">
              <span>Total</span>
              <span>PRICELESS</span>
            </div>
          </div> */}

          <button type="submit" className="place-order-btn">
            Submit
            <span>→</span>
          </button>
        </form>

        <div className="form-contact-footer">
          <span>QUESTIONS? CONTACT</span>
          <span>Patrisha & Bryan — (818) 324-6789</span>
        </div>
      </div>
    </div>
  );
}

export default RSVPForm;
